import apiClient from './api';

/**
 * Profile Service
 * Handles all profile-related API operations
 */

class ProfileService {
  /**
   * Get current user profile
   * @returns {Promise} Profile data
   */
  async getProfile() {
    try {
      const response = await apiClient.get('/api/profile');
      
      return {
        success: true,
        data: response.data.data,
        message: response.data.message,
      };
    } catch (error) {
      throw {
        success: false,
        message: error.response?.data?.message || error.message || 'Failed to fetch profile',
      };
    }
  }

  /**
   * Update profile
   * @param {Object} profileData - Profile data to update (username, phoneNumber, country, state, city, postalCode, gender)
   * @returns {Promise} Updated profile data
   */
  async updateProfile(profileData) {
    try {
      const response = await apiClient.put('/api/profile', profileData);
      
      return {
        success: true,
        data: response.data.data,
        message: response.data.message,
      };
    } catch (error) {
      throw {
        success: false,
        message: error.response?.data?.message || error.message || 'Failed to update profile',
      };
    }
  }

  /**
   * Upload profile image
   * @param {File} imageFile - Image file to upload
   * @returns {Promise} Updated profile data with new image
   */
  async uploadProfileImage(imageFile) {
    try {
      const formData = new FormData();
      formData.append('profileImage', imageFile);

      const response = await apiClient.post('/api/profile/upload-image', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      return {
        success: true,
        data: response.data.data,
        message: response.data.message,
      };
    } catch (error) {
      throw {
        success: false,
        message: error.response?.data?.message || error.message || 'Failed to upload profile image',
      };
    }
  }

  /**
   * Reset password
   * @param {string} currentPassword - Current password
   * @param {string} newPassword - New password
   * @returns {Promise} Success response
   */
  async resetPassword(currentPassword, newPassword) {
    try {
      const response = await apiClient.post('/api/profile/reset-password', {
        currentPassword,
        newPassword,
      });
      
      return {
        success: true,
        message: response.data.message,
      };
    } catch (error) {
      throw {
        success: false,
        message: error.response?.data?.message || error.message || 'Failed to reset password',
      };
    }
  }
}

export default new ProfileService();

